import { createFileRoute } from '@tanstack/react-router';
import RuleSet from '../../../../../../../../../views/DataUnification/RuleSetProtected';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/')({
  component: RuleSet,
});
